import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { App } from './app';

import 'shrike/dist/shrike.css';

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.DEBUG === 'true' ? 'staging' : 'production',
    ignoreErrors: ['Non-Error promise rejection captured with value:'],
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.2,
  });
}

// shows everywhere but production - remove this if block once Spanish goes live
if (process.env.DEBUG === 'true') {
  window.Localize.showWidget();
}

ReactDOM.render(<App />, document.getElementById('root'));
